<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title help-btn">
            {{ params['title'] | translate }}
        </h4>
    </div>
    <div class="modal-body">
        <edit-modal-header-action-component [params]="params"  (openFormModalAction)="openFormModal.emit()"  (deleteAction)="delete.emit()" (hideModalAction)="hideModal.emit()"> </edit-modal-header-action-component>

        <ng-template [ngIf]="!formLoading">
            <form [formGroup]="form" novalidate class="mat-form" #formDirective="ngForm">

                <div class="row">
                    <div class="form-group col-xs-4">
                        <mat-form-field class="ps-content">
                            <mat-select [placeholder]="'Logo' | translate" formControlName="logo_id" (selectionChange)="updateLogo($event.value)">
                                <mat-option value=0>
                                    {{ 'None' | translate }}
                                </mat-option>
                                <ng-container *ngFor="let logo of logos">
                                    <mat-option [value]="logo['id']">
                                        {{ logo['name'] }}
                                    </mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="form-group col-xs-12">
                        <div class="img-space">
                            <ng-container *ngIf="form.controls['logo_url'].value; else elseTemplate">
                                <img class="logo-thumbnails" width="100%" height="240" [src]="form.controls['logo_url'].value"/>
                            </ng-container>
                            <ng-template #elseTemplate>
                                <i class="fal fa-file-pdf logo-icon"></i>
                            </ng-template>
                        </div>
                    </div>
                </div>

                <ng-container *ngFor="let language of languages; let first = first">
                    <mat-expansion-panel class="mt-2"
                                            [ngClass]="((!form.controls['name_' + language['locale']].valid || !form.controls['application_duration_' + language['locale']].valid || !form.controls['description_' + language['locale']].valid)  && formSubmitted) ? 'invalid': ''"
                                            [expanded] = "first || params['action'] === 'create'"
                                            (opened)="panelOpenState = true"
                                            (closed)="panelOpenState = false">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                {{ language['name'] }}
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <div class="container">
                            <div class="row">
                                <div class="form-group col-xs-5">
                                    <mat-form-field class="ps-content">
                                        <input matInput type="text" [placeholder]="('Name' | translate)"
                                                [formControlName]="'name_' + language['locale']"/>
                                        <small class="form-text text-danger" [hidden]="(form.controls['name_' + language['locale']].pristine
                                                                            && !formSubmitted) || form.controls['name_' + language['locale']].valid">
                                            {{ 'Require at least 3 characters.' | translate }}
                                        </small>
                                    </mat-form-field>
                                </div>

                                <div class="form-group col-xs-5">
                                    <mat-form-field class="ps-content">
                                        <input type="text" matInput [placeholder]="('Application duration' | translate)"
                                                [formControlName]="'application_duration_' + language['locale']"/>
                                        <small class="form-text text-danger" [hidden]="form.controls['application_duration_' + language['locale']].valid
                                                                            || (form.controls['application_duration_' + language['locale']].pristine
                                                                            && !formSubmitted)">
                                            {{ 'Require at least 3 characters.' | translate }}
                                        </small>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-xs-5">
                                    <mat-form-field class="ps-content">
                                        <textarea matInput [formControl]="form.controls['description_' + language['locale']]"
                                                placeholder="{{ 'Description' | translate }}"
                                                rows="2">
                                        </textarea>
                                        <small class="form-text text-danger" [hidden]="form.controls['description_' + language['locale']].valid
                                                                            || (form.controls['description_' + language['locale']].pristine
                                                                            && !formSubmitted)">
                                            {{ 'Require at least 3 characters.' | translate }}
                                        </small>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </ng-container>
                <div class="row mt-2">
                    <div class="form-group col-xs-4">
                        <mat-form-field class="ps-content">
                            <mat-select [placeholder]="'Category' | translate" formControlName="category_id" (selectionChange)="updateSubCategory($event.value)">
                                <ng-container *ngFor="let category of categories">
                                    <mat-option [value]="category['id']">
                                        {{ category['name_' + itemLanguage] }}
                                    </mat-option>
                                </ng-container>
                            </mat-select>
                            <small class="form-text text-danger" [hidden]="form.controls.category_id.valid || (form.controls.category_id.pristine && !formSubmitted)">
                                {{ 'This field is required.' | translate }}
                            </small>
                        </mat-form-field>
                    </div>
                    <div class="form-group col-xs-4">
                        <mat-form-field class="ps-content">
                            <mat-select [placeholder]="'Sub-Category' | translate" formControlName="subcategory_id">
                                <mat-option value="0">
                                    {{ 'Unselected' | translate }}
                                </mat-option>
                                <ng-container *ngFor="let subcategory of subcategoryList">
                                    <mat-option [value]="subcategory['id']">
                                        {{ subcategory['name_' + itemLanguage] }}
                                    </mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="form-group col-xs-4">
                        <mat-form-field class="ps-content">
                            <mat-select [placeholder]="'Company' | translate" formControlName="company_id">
                                <mat-option value=0>
                                    {{ 'None' | translate }}
                                </mat-option>
                                <ng-container *ngFor="let company of companies">
                                    <mat-option [value]="company['id']">
                                        {{ company['name'] }}
                                    </mat-option>
                                </ng-container>
                            </mat-select>
                            <small class="form-text text-danger" [hidden]="form.controls.company_id.valid || (form.controls.company_id.pristine && !formSubmitted)">
                                {{ 'This field is required.' | translate }}
                            </small>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="form-group col-xs-4">
                        <mat-form-field class="ps-content">
                            <mat-select [placeholder]="'Age group' | translate" formControlName="age_group_id">
                                <mat-option value=0>
                                    {{ 'None' | translate }}
                                </mat-option>
                                <ng-container *ngFor="let ageGroup of ageGroups">
                                    <mat-option [value]="ageGroup['id']">
                                        {{ ageGroup['name_' + itemLanguage] }}
                                    </mat-option>
                                </ng-container>
                            </mat-select>
                            <small class="form-text text-danger" [hidden]="form.controls.age_group_id.valid || (form.controls.age_group_id.pristine && !formSubmitted)">
                                {{ 'This field is required.' | translate }}
                            </small>
                        </mat-form-field>
                    </div>
                    <div class="form-group col-xs-4">
                        <mat-form-field class="ps-content">
                            <mat-select [placeholder]="'Insurance' | translate" formControlName="insurance_id">
                                <mat-option value=0>
                                    {{ 'None' | translate }}
                                </mat-option>
                                <ng-container *ngFor="let insurance of insurances">
                                    <mat-option [value]="insurance['id']">
                                        {{ insurance['name_' + itemLanguage] }}
                                    </mat-option>
                                </ng-container>
                            </mat-select>
                            <small class="form-text text-danger" [hidden]="form.controls.insurance_id.valid || (form.controls.insurance_id.pristine && !formSubmitted)">
                                {{ 'This field is required.' | translate }}
                            </small>
                        </mat-form-field>
                    </div>
                    <div class="form-group col-xs-4">
                        <mat-form-field class="ps-content">
                            <mat-select
                                        [placeholder]="'Languages' | translate"
                                        class="matSelect-domains"
                                        formControlName="language_ids"
                                        multiple>
                                <input formControlName="searchLanguageTxt"
                                       class="matSelect-domains--filter"
                                       type="text"
                                       matInput
                                       [placeholder]="('Search' | translate)">
                                <ng-container *ngFor="let serviceProviderLang of serviceProviderLanguage | searchArray : form.controls['searchLanguageTxt'].value : 'code' ">
                                    <mat-option [class.hidden]="serviceProviderLang['hidden']" [selected]="form.controls['language_ids']?.value?.indexOf(serviceProviderLang['id']) > -1" [value]="serviceProviderLang['id']">
                                        {{ serviceProviderLang['code'] | translate }}
                                    </mat-option>
                                </ng-container>
                            </mat-select>
                            <small class="form-text text-danger" [hidden]="form.controls.language_ids.valid || (form.controls.language_ids.pristine && !formSubmitted)">
                                {{ 'This field is required.' | translate }}
                            </small>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="form-group col-xs-4">
                        <mat-form-field class="ps-content">
                            <input type="text" matInput [placeholder]="('Website' | translate)"
                                    [formControlName]="'website'"/>
                        </mat-form-field>
                    </div>
                    <div class="form-group col-xs-4">
                        <div class="row">
                            <div class="label col-xs-12">{{ 'Digital therapy' | translate }}</div>
                            <div class="col-xs-12">
                                <div class="row">
                                    <div class="col-xs-12">
                                        <input type="range" min="0" max="1" step="1" formControlName="digital_therapy"/>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-6" [class.label--bold]="form.controls.digital_therapy.value === 0">
                                        {{ 'Not allowed' | translate }}
                                    </div>
                                    <div class="col-xs-6 text-xs-right" [class.label--bold]="form.controls.digital_therapy.value === 1">
                                        {{ 'Allowed' | translate }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group col-xs-4">
                        <div class="row">
                            <div class="label col-xs-12">{{ 'Group therapy' | translate }}</div>
                            <div class="col-xs-12">
                                <div class="row">
                                    <div class="col-xs-12">
                                        <input type="range" min="0" max="1" step="1" formControlName="group_therapy"/>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-6" [class.label--bold]="form.controls.group_therapy.value === 0">
                                        {{ 'Not allowed' | translate }}
                                    </div>
                                    <div class="col-xs-6 text-xs-right" [class.label--bold]="form.controls.group_therapy.value === 1">
                                        {{ 'Allowed' | translate }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="form-group col-xs-4">
                        <mat-form-field class="ps-content">
                            <input matInput type="text" [placeholder]="('Zip code' | translate)"
                                    [formControlName]="'zip_code'"/>
                        </mat-form-field>
                    </div>
                    <div class="form-group col-xs-4">
                        <mat-form-field class="ps-content">
                            <input matInput type="text" [placeholder]="('State' | translate)"
                                [formControlName]="'state'"/>
                        </mat-form-field>
                    </div>
                    <div class="form-group col-xs-4">
                        <mat-form-field class="ps-content">
                            <mat-select [placeholder]="'Country' | translate" formControlName="country_id">
                                <ng-container *ngFor="let country of countries">
                                    <mat-option [value]="country['id']">
                                        {{ country['name'] }}
                                    </mat-option>
                                </ng-container>
                            </mat-select>
                            <small class="form-text text-danger" [hidden]="form.controls.country_id.valid || (form.controls.country_id.pristine && !formSubmitted)">
                                {{ 'This field is required.' | translate }}
                            </small>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="form-group col-xs-6">
                        <mat-form-field class="ps-content">
                            <mat-select [placeholder]="'Diagnoses' | translate"
                                        class="matSelect-domains"
                                        formControlName="diagnosis_ids"
                                        multiple>
                                <input formControlName="searchDiagnosisTxt"
                                       class="matSelect-domains--filter"
                                       type="text"
                                       matInput
                                       [placeholder]="('Search' | translate)">
                                <ng-container *ngFor="let diagnosis of diagnoses  | searchArray : form.controls['searchDiagnosisTxt'].value : 'code' ">
                                    <mat-option [class.hidden]="diagnosis['hidden']" [selected]="form.controls['diagnosis_ids']?.value?.indexOf(diagnosis['id']) > -1" [value]="diagnosis['id']">
                                       {{ diagnosis['code'] }}
                                    </mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="form-group col-xs-6">
                        <mat-form-field class="ps-content">
                            <mat-select [placeholder]="'Contraindications' | translate"
                                        class="matSelect-domains"
                                        formControlName="contraindications_ids"
                                        multiple>
                                <input formControlName="searchContradicationTxt"
                                       class="matSelect-domains--filter"
                                       type="text"
                                       matInput
                                       [placeholder]="('Search' | translate)">
                                <ng-container *ngFor="let diagnosis of contraindicationDiagnoses  | searchArray : form.controls['searchContradicationTxt'].value : 'code' ">
                                    <mat-option [class.hidden]="diagnosis['hidden']" [selected]="form.controls['contraindications_ids']?.value?.indexOf(diagnosis['id']) > -1" [value]="diagnosis['id']">
                                        {{ diagnosis['code'] }}
                                    </mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-xs-6">
                        <label class="lbl-card">
                            {{ 'Selected Diagnoses' | translate}}
                        </label>
                        <div class="selected-domains">
                            <ng-container *ngFor="let item of diagnoses">
                                <div class="row selected-domains--item" *ngIf="form.controls['diagnosis_ids']?.value?.indexOf(item['id']) > -1">
                                    <div class="col-xs-10">
                                        <span>
                                            {{item['code']}} <br/>
                                        </span>
                                    </div>
                                    <div class="col-xs-2">
                                        <a *ngIf="params['action'] !== 'read'" class="btn btn-link table--grid__action-btn" (click)="removeDiagnosis(item)">
                                            <i class="far fa-trash-alt table--grid__actions__links__icon"
                                               attr.name="{{ 'Delete' | translate }}" aria-hidden="true"
                                               title="{{ 'Delete' | translate }}" aria-hidden="true"></i>
                                        </a>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <div class="col-xs-6">
                        <label class="lbl-card">
                            {{ 'Selected Contraindications' | translate}}
                        </label>
                        <div class="selected-domains">
                            <ng-container *ngFor="let item of diagnoses">
                                <div class="row selected-domains--item" *ngIf="form.controls['contraindications_ids']?.value?.indexOf(item['id']) > -1">
                                    <div class="col-xs-10">
                                        <span>
                                            {{item['code']}} <br/>
                                        </span>
                                    </div>
                                    <div class="col-xs-2">
                                        <a *ngIf="params['action'] !== 'read'" class="btn btn-link table--grid__action-btn" (click)="removeContraindication(item)">
                                            <i class="far fa-trash-alt table--grid__actions__links__icon"
                                               attr.name="{{ 'Delete' | translate }}" aria-hidden="true"
                                               title="{{ 'Delete' | translate }}" aria-hidden="true"></i>
                                        </a>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>

                <div class="row mt-2">
                    <div class="col-xs-12 text-xs-right">
                        <button type="button" class="btn btn-secondary" (click)="hideModal.emit()">
                            {{ 'Cancel' | translate }}
                        </button>
                        <button *ngIf="params['action'] !== 'read'" type="button" class="btn btn-primary" (click)="submit.emit()">
                            {{ 'Submit' | translate }}
                        </button>
                    </div>
                </div>
            </form>
        </ng-template>
    </div>
</div>